export default __webpack_public_path__ + "static/media/inner13.149f8e07.jpg";